import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '@/styles/Abilities/CharacterSpellsCollectionForm.less';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SpellsHorizontalList } from '@/components/Abilities/Spells/SpellsHorizontalList';
import SearchForm from '@/components/Spells/SearchForm';
import { sortSpells } from '@/utils/sort';
export const CharacterSpellsCollectionForm = (props) => {
    const { onClose, onChange, characterSpells, spells, characterClass } = props;
    const { t } = useTranslation();
    const initialCharacterSpells = useMemo(() => characterSpells || [], [characterSpells]);
    const [filteredSpells, setFilteredSpells] = useState(sortSpells(spells));
    const [selectedSpells, setSelectedSpells] = useState(sortSpells(initialCharacterSpells));
    const handleCardClick = (spellCard) => {
        setSelectedSpells((prev) => {
            if (prev.includes(spellCard)) {
                // Удаляем из selected, возвращаем в filtered
                setFilteredSpells((filtered) => sortSpells([...filtered, spellCard]));
                return prev.filter((s) => s !== spellCard);
            }
            // Добавляем в selected, убираем из filtered
            setFilteredSpells((filtered) => filtered.filter((s) => s !== spellCard));
            return sortSpells([...prev, spellCard]);
        });
    };
    const handleFilterChange = (filtered) => {
        const excludedSelected = filtered.filter((s) => !selectedSpells.some((spell) => spell.index === s.index));
        if (excludedSelected.length !== filteredSpells.length ||
            excludedSelected.some((s, i) => { var _a; return s.index !== ((_a = filteredSpells[i]) === null || _a === void 0 ? void 0 : _a.index); })) {
            setFilteredSpells(sortSpells(excludedSelected));
        }
    };
    useEffect(() => {
        if (selectedSpells.length !== initialCharacterSpells.length) {
            onChange === null || onChange === void 0 ? void 0 : onChange(selectedSpells);
        }
    }, [selectedSpells, onChange, initialCharacterSpells]);
    return (_jsx("div", { className: "character-spells-collection-form", children: _jsxs("div", { className: "wrapper", children: [onClose && (_jsx("button", { type: "button", className: "close-btn", onClick: onClose, children: "x" })), _jsx("h3", { style: { marginTop: 0 }, className: "text-center color-muted", children: t('spells.allSpells') }), _jsx(SearchForm, { spells: spells, onFilteredChange: handleFilterChange, defaultFilters: {
                        class: characterClass ? characterClass : '',
                    } }), _jsx("div", { className: "spells-container", children: _jsx(SpellsHorizontalList, { spells: filteredSpells, handleCardClick: handleCardClick }) }), _jsxs("div", { className: "selected-spells", children: [_jsx("h3", { style: { marginTop: 0 }, className: "text-center color-muted", children: t('spells.selectedSpells') }), _jsx("div", { className: "spells-container", children: _jsx(SpellsHorizontalList, { spells: selectedSpells, handleCardClick: handleCardClick }) })] })] }) }));
};
